import { PageLocatorMap } from '../types/PageLocatorMap';

export const applyVehicleSelectionPage = {
  footer: {
    root: 'apply-vehicle-selection-page.footer.root',
  },
  form: {
    enterManuallyLink: 'apply-vehicle-selection-page.form.enter-manually-link',
    getRadioOption: (index: number) =>
      `apply-vehicle-selection-page.form.radio-option-${index + 1}`,
    h1: 'apply-vehicle-selection-page.form.h1',
    h2: 'apply-vehicle-selection-page.form.h2',
    radioGroupRoot: 'apply-vehicle-selection-page.form.radio-group-root',
    radioOption1: 'apply-vehicle-selection-page.form.radio-option1',
    radioOption2: 'apply-vehicle-selection-page.form.radio-option2',
    root: 'apply-vehicle-selection-page.form.root',
    submitButton: 'apply-vehicle-selection-page.form.submit-button',
  },
  header: {
    drawerButton: 'apply-vehicle-selection-page.header.drawer-button',
    previousStepButton:
      'apply-vehicle-selection-page.header.previous-step-button',
    root: 'apply-vehicle-selection-page.header.root',
  },
  progress: {
    root: 'apply-vehicle-selection-page.progress.root',
  },
} as const satisfies PageLocatorMap;
